import React from "react";
import Link from "next/link";

const CommunitySignupHelp = () => {
    return (
        <div className="space-y-4">
            <h2 className="text-xl font-semibold">Sign Up Your Community</h2>
            <p>
                Join our platform of senior living communities and connect with potential
                residents leads.
            </p>
            <div className="grid gap-4">
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">Benefits of Joining</h3>
                    <ul className="mt-2 space-y-1 text-gray-800">
                        <li>• Increased visibility to resident leads</li>
                        <li>• Streamlined resident placement process - no contracts</li>
                        <li>• Lead owners</li>
                        <li>• Collaboration with leads</li>
                        <li>• Seniors in crisis - see vacancies immediately</li>
                    </ul>
                </div>
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">Book a Time</h3>
                    <p className="text-gray-800 mt-1">
                        <Link
                            href="https://meetings.hubspot.com/community49"
                            className="text-primary-600 hover:text-primary-800 underline font-bold"
                        >
                            Book a time
                        </Link>{" "}
                        to schedule a demo - help signing up.
                    </p>
                </div>
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">Contact Us</h3>
                    <p className="text-gray-800 mt-1">
                        Visit our{" "}
                        <Link
                            href="/contact-us"
                            className="text-primary-600 hover:text-primary-800 underline font-bold"
                        >
                            contact page
                        </Link>{" "}
                        and an advisor will contact you.
                    </p>
                </div>
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">Call Us</h3>
                    <p className="text-gray-800 mt-1">
                        Reach us at{" "}
                        <a
                            href="tel:6127877533"
                            className="text-primary-600 hover:text-primary-800 font-bold"
                        >
                            (612) PURPLE-3
                        </a>{" "}
                        or{" "}
                        <a
                            href="tel:6127877533"
                            className="text-primary-600 hover:text-primary-800 font-bold"
                        >
                            (612) 787-7533
                        </a>
                    </p>
                </div>
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">Get Started Now</h3>
                    <p className="text-gray-800 mt-1">
                        Ready to join? Visit our{" "}
                        <Link
                            href="/community-portal"
                            className="text-primary-600 hover:text-primary-800 underline font-bold"
                        >
                            community portal
                        </Link>{" "}
                        to start adding your community/agency.
                    </p>
                </div>
            </div>
            <p className="text-sm text-gray-500 mt-4">
                Our team is available during business hours to help you get started.
            </p>
        </div>
    );
};

export default CommunitySignupHelp;
